import script from "./OptimizationFormComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./OptimizationFormComponent.vue?vue&type=script&setup=true&lang=js"

import "./OptimizationFormComponent.vue?vue&type=style&index=0&id=388b1198&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-388b1198"]])

export default __exports__